import { Text } from '@opendoor/atoms/text';

import { ContentCard } from './ContentCard';
import { ContentWrapper } from './ContentWrapper';

type Link = {
  url: string;
  title: string;
};

const TUTORIAL_LINKS: Array<Link> = [
  {
    url: 'https://university.opendoor.com/hc/en-us/articles/360039478431-Referral-Dashboard-for-Sales-Associates-',
    title: 'Tutorial: How to use the Opendoor Referral Dashboard',
  },
];

const OD_UNIVERSITY_LINKS: Array<Link> = [
  {
    url: 'https://university.opendoor.com/hc/en-us/articles/360040522471-Seller-Benefits-the-3-C-s-1-',
    title: 'Benefits of selling to Opendoor',
  },
];

const LearningCenterSection = () => {
  return (
    <ContentWrapper>
      <ContentCard title="Learning Center">
        <Text as="h4" className="text-subheader-xs pb-2.5">
          Tutorials and Webinars
        </Text>
        <ul>
          {TUTORIAL_LINKS.map((link) => (
            <li key={link.title}>
              <a href={link.url} target="_blank" rel="noopener noreferrer">
                {link.title}
              </a>
            </li>
          ))}
        </ul>
        <Text as="h4" className="text-subheader-xs py-2.5">
          Opendoor University
        </Text>
        <ul>
          {OD_UNIVERSITY_LINKS.map((link) => (
            <li key={link.title} style={{ marginBottom: '2px' }}>
              <a href={link.url} target="_blank" rel="noopener noreferrer">
                {link.title}
              </a>
            </li>
          ))}
        </ul>
      </ContentCard>
    </ContentWrapper>
  );
};

export default LearningCenterSection;
